import logger from '../utils/rbmc.logger';

const productListComponent = {
    $recommendationComp: null,
    minProductToShow: 8,
    fetchRecommendations() {
        let url     = this.$recommendationComp.data('url');
        let request = $.ajax({
            url:    url,
            method: 'GET',
            cache:  false
        });

        request.done((response) => {
            let numberOfProducts = $(response).filter('.pl-component__item').length;
            let $target          = $('#recommendation-comp__products');

            // append products
            $target.html(response);
            // button need data-count for the correct work
            this.$recommendationComp.find('.pl-component__btn').data('count', numberOfProducts);
            // remove button if there are less products in the response
            if (numberOfProducts <= productListComponent.minProductToShow) {
                this.$recommendationComp.find('.pl-component__footer--lazy').remove();
            }
            // make component visible
            this.$recommendationComp.removeClass('pl-component--lazy');
        });
        request.fail((jqXHR, textStatus) => {
            logger.error("error in fetchRecommendations");
        });

    },
    bindHandler() {
        $(document.body).on('click', '.pl-component__main', (evt) => {
            //empty for now
        });

        $(document.body).on('click', '.pl-component__btn', (evt) => {
            let self           = evt.currentTarget;
            let dataSet        = self.dataset;
            // the next candidates to unveil
            let targetProducts = $(dataSet.target).find('.pl-component__item--hidden:lt(' + dataSet.pagesize + ')');
            targetProducts.removeClass('pl-component__item--hidden');
            // button can be removed. There are no more products for a next loop
            if ($(dataSet.target).find('.pl-component__item--hidden').length === 0) {
                $(self).remove();
            }
        });
    }
};

$(() => {
    productListComponent.$recommendationComp = $('#recommendation-comp');
    if ($('.pl-component').length) {
        productListComponent.bindHandler();
    }
    if (productListComponent.$recommendationComp.length) {
        productListComponent.fetchRecommendations();
    }
});

export default productListComponent;
